import { DAY_MS } from "./freshness.js";

// The read window for the Metabolic card, owned in one place because it is
// read from two mounts — apps/mobile's useMetabolic and apps/web-rnw's
// useMetabolicWeb — which must show the same rows for the same athlete. The
// two hooks stay separate (they can't share `apiFetch`, whose implementation
// is deliberately per-mount), but the WINDOW and the query they build are not
// a mount concern, and when they were written out by hand in both files the
// two could drift silently: nothing would fail, the web card would just show
// a different span than the phone.
//
// ⚠️ OPEN, and deliberately not decided here: 30 is what both mounts always
// hardcoded, but Progress's own window default is 90
// (ui/Progress/progressWindow.ts DEFAULT_WINDOW_DAYS), consumed by seven
// panels. Nobody ever chose 30 against 90 — the census entry
// CN-metabolic-window calls it drift, not design. Naming the constant is
// half the fix; the other half is a product call about how much history the
// Metabolic card should show, so it is left to Antenore rather than settled
// by whoever touched the file. Do NOT quietly align it to 90: that changes
// what the athlete sees.
export const METABOLIC_WINDOW_DAYS = 30;

// Page cap. The API caps its own page anyway; this keeps the card light and
// makes the ceiling visible at the call site rather than implicit.
export const METABOLIC_READ_LIMIT = 500;

// Query string for GET /api/me/glucose and /api/me/nutrition — the same
// window and cap for both endpoints, which is the point.
//
// `nowMs` is injectable so the window can be pinned without stubbing the
// clock — apps/mobile/__tests__/metabolicRead.test.ts does exactly that.
// Production callers omit it.
export const metabolicReadQuery = (nowMs: number = Date.now()): string => {
  const since = new Date(nowMs - METABOLIC_WINDOW_DAYS * DAY_MS).toISOString();
  return `since=${encodeURIComponent(since)}&limit=${METABOLIC_READ_LIMIT}`;
};
